<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body add-alarm-container">
          <div class="mb-3">
            <Stepper :step="step" :labels="labels" />
          </div>
          <add-alarm
            :step="step"
            @goBack="goBack"
            @goNext="goNext"
            @closeAddAlarm="closeAddAlarm"
            @step="goStep"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Stepper from "../../components/Stepper";
import AddAlarm from "./AddAlarm.vue";


export default {
  components: {
    Stepper,
    AddAlarm,
  },
  data() {
    return {
      showAddAlarm: false,
      labels: [
        this.$t("add_alarms"),
        this.$t("add_devices_users"),
        this.$t("summary"),
      ],
      step: 1,
    };
  },
  methods: { 
    goBack() {
      console.log("go back");
      if (this.step == 1) {
        this.showAddAlarm = false;
      } else this.step--;
    },
    goNext() {
      this.step++;
    },
    goStep(step) {
      this.step = step;
    },
    closeAddAlarm() {
      this.showAddAlarm = false
      // this.$router.push("/alarms");
    },
  },
};
</script>

<style scoped>
</style>